import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import "../../../assets/MB_OB_UBRF_3_1/css/MB_OB_UBRF_3_1.scss";
import Header from "../../Includes/Layouts/MB_OB_UBRF_3_1/Header";
import Footer from "../../Includes/Layouts/Common/Footer";
import Section1 from "../../Includes/Layouts/MB_OB_UBRF_3_1/Section1";
import AccordSection from "../../Includes/Layouts/Common/AccordSection";
import FormMB_OB_UBRF_3_1 from "../../Forms/FormMB_OB_UBRF_3_1";
import FbViewPixel from "../../../Utility/FbViewPixel";

const MB_OB_UBRF_3_1 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="MB_OB_UBRF_3_1" />
      <FbViewPixel />
      <div className="MB_OB_UBRF_3_1">
        <Header />
        <section className="form-part" id="firstform">
          <div className="container nopad">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 nopad">
              <FormMB_OB_UBRF_3_1 />
            </div>
          </div>
        </section>
        <Section1 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default MB_OB_UBRF_3_1;
